/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PeriodResponsePage } from '../../models/period-response-page';

export interface ListPeriods$Params {
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'startDate' | '-startDate' | 'endDate' | '-endDate'>;
}

export function listPeriods(http: HttpClient, rootUrl: string, params?: ListPeriods$Params, context?: HttpContext): Observable<StrictHttpResponse<PeriodResponsePage>> {
  const rb = new RequestBuilder(rootUrl, listPeriods.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PeriodResponsePage>;
    })
  );
}

listPeriods.PATH = '/v0/explore-graph/periods';
